export * from './sc-msg-list/msg-list.component';
export * from './sc-msg-detail/msg-detail.component';
export * from './kw-msg-list/msg-list.component';
export * from './kw-msg-detail/msg-detail.component';
